import { useEffect, useState, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import PublicHeader from './header/PublicHeader';
import SecureHeader from './header/SecureHeader';
import Footer from '../components/footer/footer';
import { setPortalType, setLoadingProgress } from '../../redux/app/appSlice';
import LoadingBar1 from './common/top-loading-bar/variant1';
import SideNavBar from '../components/sidenavbar/sidenavbar';
import { USER_TYPES, USE_PERSONA_FRAMEWORK } from 'src/constants';
import './common/top-loading-bar/loading-bar.scss';
import { hexToRgb } from 'src/utils';
import { ToastContainer } from 'react-toastify';
//import 'antd/dist/antd.css';
const FallBackLoader = () => {
  //eslint-disable-next-line no-unused-vars
  const { t } = useTranslation();

  return null;
};

const AdminLayout = (props) => {
  console.log('rendering admin layout');
  const dispatch = useDispatch();

  const { portalType, loadingNum, isTokenExpired } = useSelector(
    (state) => state.app,
  );
  const { isLoggedIn, userData, hasSecurityQuestions } = useSelector(
    (state) => state.user,
  );
  const [isSecurityQuestionsAvailable, setIsSecurityQuestionsAvailable] =
    useState(false);

  const { branding } = useSelector((state) => state.theme);
  const [isAdmin, setAdmin] = useState(false);

  const location = useLocation();

  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [timeOutRedirect, setTimeOutRedirect] = useState(false);

  useEffect(() => {
    if (USE_PERSONA_FRAMEWORK) {
      setIsSecurityQuestionsAvailable(hasSecurityQuestions);
    } else {
      setIsSecurityQuestionsAvailable(true);
    }
  }, [hasSecurityQuestions]);

  useEffect(() => {
    const root = document.documentElement;
    if (branding && branding?.ThemeValues !== undefined) {
      branding.ThemeValues.forEach((element) => {
        root.style.setProperty(
          '--' + element.BrandingKey,
          element.BrandingValue,
        );
        root.style.setProperty(
          '--' + element.BrandingKey + '-rgb',
          hexToRgb(element.BrandingValue),
        );
      });
      root.style.setProperty('--HeadingFont', branding.HeadingFont);
      root.style.setProperty('--ParagraphFont', branding.ParagraphFont);
    }
  }, [branding]);

  useEffect(() => {
    if (userData) {
      if (
        USER_TYPES.EMPLOYEE === userData.UserType ||
        USER_TYPES.DEPENDENT === userData.UserType
      ) {
        const redirectToUrl = '/member/dashboard';
        setRedirectUrl(redirectToUrl);
        setShouldRedirect(true);
      }
    }
  }, []);

  useEffect(() => {
    if (
      (!portalType || portalType !== 'admin') &&
      location.pathname.includes('/admin')
    ) {
      dispatch(setPortalType('admin'));
    }
  }, []);

  useEffect(() => {
    if (isTokenExpired && !timeOutRedirect) {
      setTimeOutRedirect(true);
    }
    if (!isTokenExpired) {
      setTimeOutRedirect(false);
    }
  }, [isTokenExpired]);

  useEffect(() => {
    if (location.pathname.includes('/admin')) {
      setAdmin(true);
    } else {
      setAdmin(false);
    }
  }, [location.pathname, isLoggedIn]);

  if (isAdmin) {
    return (
      <>
        {
          <>
            <LoadingBar1
              progress={100 - loadingNum * 10}
              onLoaderFinished={() => {
                dispatch(setLoadingProgress(0));
              }}
            />
            {timeOutRedirect && <Navigate to="/admin/session-expired" />}
            <div className={isLoggedIn ? 'post-login' : ''}>
              {!isLoggedIn && <PublicHeader />}
              {isLoggedIn && isSecurityQuestionsAvailable && (
                <div className="dashboard-sidebar">
                  <SideNavBar />
                </div>
              )}

              {isLoggedIn && (
                <SecureHeader
                  isSecurityQuestionsAvailable={isSecurityQuestionsAvailable}
                />
              )}

              <Suspense fallback={<FallBackLoader />}>
                <div
                  className={
                    isLoggedIn
                      ? location.pathname.includes('/admin/view-member') ||
                        location.pathname.includes('/admin/reports') ||
                        location.pathname.includes(
                          '/admin/search-claims-results',
                        ) ||
                        location.pathname.includes(
                          'admin/Messages-Documents',
                        ) ||
                        location.pathname.includes('admin/approvals') ||
                        location.pathname.includes(
                          '/admin/price-compare/search-results',
                        ) ||
                        location.pathname.includes(
                          '/admin/enumeration-audit',
                        ) ||
                        location.pathname.includes(
                          '/admin/enrollment-life-event',
                        ) ||
                        location.pathname.includes('/admin/enrollment-coverage')
                        ? ''
                        : 'container-offset'
                      : 'public-container-offset custom-height'
                  }
                >
                  {props.children}
                </div>
              </Suspense>

              <Footer />

              <div className="toastify">
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </div>

              {shouldRedirect && <Navigate to={redirectUrl} />}
            </div>
          </>
        }
      </>
    );
  }
  return null;
};

export default AdminLayout;
